import React, { Component } from "react";
import { connect } from "react-redux";

import { setLevel, showModal, undo } from "actions";

import "./Undo.scss";
import undoIcon from "./img/undo-modal-icon.svg";

import { withTranslation } from 'react-i18next'
import {LogEvent} from '@learningblocks/shared-components/lib/EventLogger'; 

class Undo extends Component {

  noClicked = () => {
    this.props.showModal(false);
  };

  yesClicked = () => {
    if (this.props.restarts > 0 && Object.keys(this.props.snapshots).length > 0) {

      if(Object.hasOwn(this.props.snapshots, 'back2')){
        this.props.undo({
          lastState: this.props.snapshots.back2
        });
      } else {
        this.props.undo({
          lastState: this.props.snapshots.back1
        });
      }

    }

    this.props.showModal(false);
  };

  renderTaskIndex = () => {
    return this.props.page + "." + String.fromCharCode(97 + this.props.task.index)
  }

  render() {
    return (
      <div className="modal-section undo">
        <img alt="Undo Icon" src={undoIcon} className="undoModalIcon" />

        <h4 className="restartModalHeading" aria-label={this.props.t("Are you sure you want to undo this step?")}>
          {this.props.t("Are you sure you want to undo this step?")}
        </h4>

        {/* <p className="taskText">{this.renderTaskIndex()} {this.props.task.levels["l"+this.props.level].task}</p> */}

        <p className="restartsLeftText" aria-label={this.props.restarts+ " "+this.props.t("restarts left")}>{this.props.restarts} {this.props.t("restarts left")}</p>
        <div className="modal-footer">
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_undo rejected",
              event_schema: "track",
              success: false
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              aria-label={this.props.t("No")}
              tabIndex={this.props.tab}
              className="modal-btn-secondary lvl-choice"
              onClick={this.noClicked}
            >
              {this.props.t("No")}
            </button>
          </LogEvent>
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_undo accepted",
              event_schema: "track",
              success: true
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              aria-label={this.props.t("Yes")}
              tabIndex={this.props.tab}
              className="modal-btn-primary lvl-choice"
              onClick={this.yesClicked}
            >
              {this.props.t("Yes")}
            </button>
          </LogEvent>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    task: state.notebook.focusedTaskObj,
    restarts: state.undo.attempts,
    level: state.notebook.level,
    page: state.notebook.currentProtocolPage,
    lastState: state.undo.snapshots.back1,
    snapshots: state.undo.snapshots,
  };
};

export default connect(
  mapStateToProps,
  {
    setLevel,
    showModal,
    undo,
  }
)(withTranslation()(Undo));
